module.exports = __webpack_public_path__ + "public/img/rubbish.468edc4d.png";